import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _, { get } from 'lodash'
import { FormControl } from 'react-bootstrap'
import TagsInput from 'react-tagsinput'

import { onConfirm } from 'Shared/helpers'
import PopupTypes from '../../popup_types'
import {
  GlgPopup,
  GlgPopupForm,
  GlgFormInput,
  GlgSelect,
  GlgFormTextInput,
  GlgOptionsList,
  GlgInlineSuggest,
} from 'SharedComponents'


class NavigatorOptionPopup extends Component {
  constructor(props) {
    super(props)
    this.onClose = props.onClose.bind(this, PopupTypes.NAVIGATOR_OPTION_POPUP)
    this.onValidityChange = this.onValidityChange.bind(this)
    this.handleAlternateTagsChange = this.handleTagsChange.bind(this, 'alternateTags')
    this.handleTagsChange = this.handleTagsChange.bind(this, 'tags')
    this.onSave = this.onSave.bind(this)

    this.state = {
      invalidCount: 0,
      tags: [],
      alternateTags: [],
      location: '',
    }
  }

  // When the popup is opened
  componentDidUpdate(prevProps) {
    if (this.props.show && !prevProps.show) {
      if (prevProps.data.tags !== this.props.data.tags ||
          prevProps.data.alternateTags !== this.props.data.alternateTags ||
          prevProps.data.location !== this.props.data.location) {
        this.setState({
          tags: this.props.data.tags,
          alternateTags: this.props.data.alternateTags,
          location: this.props.data.location,
        })
      } else if (this.props.data.operation === 'add' &&
                 (!_.isEmpty(this.state.tags) ||
                  !_.isEmpty(this.state.alternateTags) ||
                  !_.isEmpty(this.state.location)
                 )) {
        this.setState({
          tags: [],
          alternateTags: [],
          location: '',
        })
      }
      const newInvalidCount = this.getInvalidCount(this.props.data)
      if (this.state.invalidCount !== newInvalidCount) {
        this.setState({
          invalidCount: newInvalidCount,
        })
      }
    }
  }

  getInvalidCount(data) {
    let count = 0
    if (_.isEmpty(data.name)) {
      count++
    }
    if (_.isEmpty(data.internalId)) {
      count++
    }
    return count
  }

  onSave(data, onClose) {
    const navigatorOption = data.navigator_option
    const name = navigatorOption.name

    const popupData = {
      navigatorOption: {
        name: navigatorOption.name,
        context: navigatorOption.context,
        internalId: navigatorOption.internal_id,
        location: navigatorOption.location,
        url: navigatorOption.url,
        weight: navigatorOption.weight,
        tags: this.state.tags,
        alternateTags: this.state.alternateTags,
      },
      helpLinks: data.help_links,
    }
    if (this.props.data.operation === 'edit') {
      onConfirm(`Are you sure you want to save the ${ name } option?`, () => {
        this.props.onOptionEdit(this.props.data.id, popupData)
        onClose()
      })
    } else if (this.props.data.operation === 'add') {
      this.props.onOptionCreate(popupData)
      onClose()
    }
  }

  onValidityChange(valid) {
    const invalidCountDelta = valid ? -1 : +1
    this.setState(state => ({
      ...state,
      invalidCount: state.invalidCount + invalidCountDelta,
    }))
  }

  isFormValid() {
    return this.state.invalidCount === 0
  }

  handleTagsChange(key, tags) {
    this.setState({
      [key]: tags,
    })
  }

  getTitle() {
    if (!this.props.data) {
      return ''
    }
    return `${ _.capitalize(this.props.data.operation) } Navigator Option`
  }

  render() {
    return (
      <GlgPopup title={ this.getTitle() }
                saveButtonText="Save"
                saveButtonEnabled={ this.isFormValid() }
                show={ this.props.show }
                modalClass="admin-navigator-popup"
                onClose={ this.onClose }
                onSave={ this.onSave }
                manualClose={ true }>
        <GlgPopupForm leftSideColumnsCount={ 3 }>
          <GlgFormTextInput label="Name"
                            name="navigator_option[name]"
                            defaultValue={ get(this.props.data, 'name') }
                            onValidityChange={ this.onValidityChange }
                            invalidText="Navigator option's name must have at least one character."
                            autoFocus={ true } />
          <GlgFormInput label="Context">
            <GlgSelect name="navigator_option[context]"
                       items={ CONTEXT_OPTIONS }
                       defaultValue={ get(this.props.data, 'context') } />
          </GlgFormInput>
          <GlgFormInput label="URL">
            <FormControl name="navigator_option[url]"
                         type="text"
                         defaultValue={ get(this.props.data, 'url') } />
          </GlgFormInput>
          <GlgFormInput label="Location">
            <GlgInlineSuggest name="navigator_option[location]"
                           inputClass="form-control"
                           suggestions={ this.props.locationSuggestions }
                           value={ this.state.location }
                           onChange={ e => this.setState({ location: e.currentTarget.value }) } />
          </GlgFormInput>
          <GlgFormInput label="Tags">
            <TagsInput value={ this.state.tags }
                       onChange={ this.handleTagsChange }
                       onlyUnique={ true } />
          </GlgFormInput>
          <GlgFormInput label="Alternate Tags">
            <TagsInput value={ this.state.alternateTags }
                       onChange={ this.handleAlternateTagsChange }
                       onlyUnique={ true } />
          </GlgFormInput>
          <GlgFormInput label="Weight">
            <FormControl name="navigator_option[weight]"
                         type="number"
                         defaultValue={ get(this.props.data, 'weight') } />
          </GlgFormInput>
          <GlgFormTextInput label="Internal Id"
                            name="navigator_option[internal_id]"
                            defaultValue={ get(this.props.data, 'internalId') }
                            onValidityChange={ this.onValidityChange }
                            invalidText="Navigator option's internal id must have at least one character." />
          <GlgFormInput label="Help Links">
            <GlgOptionsList inputName="help_links"
                            columns={ [ 'name', 'url' ] }
                            defaultOptionValues={ get(this.props.data, 'helpLinks') }
                            placeholders={ [ 'Title', 'URL' ] } />
          </GlgFormInput>
        </GlgPopupForm>
      </GlgPopup>
    )
  }
}

NavigatorOptionPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  data: PropTypes.object,
  locationSuggestions: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onOptionEdit: PropTypes.func.isRequired,
  onOptionCreate: PropTypes.func.isRequired,
}

const CONTEXT_OPTIONS = [
  {
    value: 'event',
    label: 'Event',
  },
  {
    value: 'customer',
    label: 'Customer',
  },
]

export default NavigatorOptionPopup
